export default "__VITE_ASSET__BerNBsup__"